"use strict";
import InviteParkers from "./InviteParkers.jsx";

export const auth = true;
export const title = "i18n:user.pageTitle";
export const Component = InviteParkers;
